import Title from './src/Title.vue'

export default Title



// WEBPACK FOOTER //
// ./~/iexplore/components/title/index.js